import { pathOr } from 'ramda'
import { message } from 'antd'
import { UPLOAD_TYPES } from 'constants/constants'

export const TYPES = {
  document: {
    accept: UPLOAD_TYPES,
    limit: 5
  },
  image: {
    accept: 'image/*',
    limit: 2
  }
}

export const beforeUpload = file => {
  const isLt5M = file.size / 1024 / 1024 < 5
  if (!isLt5M) {
    message.error('File must smaller than 5MB!')
  }
  return isLt5M
}

export const beforeUploadDocuments = ({ type, size }) => {
  const isValid =
    type === 'image/jpeg' ||
    type === 'image/jpg' ||
    type === 'image/png' ||
    type === 'application/pdf'

  const isLt5M = size / 1024 / 1024 < 5

  if (!isValid) {
    message.error('Invalid file extension!')
  }

  if (!isLt5M) {
    message.error('File must smaller than 5MB!')
  }
  return isValid && isLt5M
}

export const extractFiles = (files = []) => {
  const filteredFiles = files.filter(i => i.file)

  const result = filteredFiles.map(item => {
    if (pathOr(false, ['file', 'image'], item))
      return {
        ...item,
        file: item.file.image
      }
    return item
  })

  return result.filter(item => !!item)
}
